// frontend/src/components/LazyComponents.js
// Этот файл теперь содержит только вспомогательные компоненты для ленивой загрузки,
// а не сами ленивые компоненты, чтобы избежать циклических зависимостей.

import React, { Suspense, lazy } from 'react';
import { LoadingIcon } from './Icons';
import '../styles/components.css';

// Компонент загрузки для ленивых компонентов
const ComponentLoader = ({ children, fallback }) => (
    <Suspense fallback={fallback || <DefaultLoader />}>
        {children}
    </Suspense>
);

// Дефолтный лоадер
const DefaultLoader = () => (
    <div className="lazy-loader">
        <div className="lazy-loader-content">
            <LoadingIcon className="spinning" />
            <p>Завантаження...</p>
        </div>
    </div>
);

// Кастомный лоадер для конкретных компонентов, используется в AppContent
export const StepLoader = ({ title = "Завантаження..." }) => (
    <div className="step-loader">
        <div className="step-loader-content card">
            <LoadingIcon className="spinning large" />
            <h3>{title}</h3>
            <div className="loader-progress">
                <div className="loader-bar"></div>
            </div>
        </div>
    </div>
);

// HOC для создания ленивых компонентов с retry логикой
export const withLazyRetry = (importFunc, retries = 3) => {
    return lazy(() => {
        return new Promise((resolve, reject) => {
            let attempts = 0;
            
            const attemptImport = () => {
                attempts++;
                importFunc()
                    .then(resolve)
                    .catch((error) => {
                        if (attempts < retries) {
                            console.warn(`🔄 Retry loading component (attempt ${attempts}/${retries}):`, error);
                            setTimeout(attemptImport, 1000 * attempts); // Exponential backoff
                        } else {
                            console.error(`❌ Failed to load component after ${retries} attempts:`, error);
                            reject(error);
                        }
                    });
            };
            
            attemptImport();
        });
    });
};

// Экспорт для прямого использования
export { ComponentLoader, DefaultLoader };